import React from "react";
import {isAdFreeModeEnabled} from "../common/ad-preferences";

export function AdBannerInfeed() {
    const isAdFreeMode = isAdFreeModeEnabled();

    React.useEffect(() => {
        if (isAdFreeMode) return;

        try {
            ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
        } catch (e) {
            console.log(e)
        }
    }, [isAdFreeMode]);

    if (isAdFreeMode) return null;

    return (
        <ins className="adsbygoogle"
             style={{ display: 'block' }}  // ← 여기만 수정
             data-ad-format="fluid"
             data-ad-layout-key="-gw-3+1f-3d+2z"
             data-ad-client="ca-pub-4057921282786438"
             data-ad-slot="8206737238"
        />
    );
}
